<mat-card [ngClass]="{'bg-color-card without-url' : !url && !imageChangedEvent && !onlyImg , 'rounded' : rounded, 'withUrl': !(!url && !imageChangedEvent) && !onlyImg, 'hiddenPreview' : hiddenPreview, 'dragging-over': isDraggingOver }"  fxLayout="column" fxLayoutAlign="center center" fxFill
  (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">

  @if ((url || localUrl) && !onlyImg) {
  <div class="img-loaded-container" [class.with-file-info]="isIconImage" fxLayout="row" fxLayoutAlign="center center">
    @if (!hiddenPreview) {
    <img class="img-uploaded" [src]="(url || localUrl) | safeUrl" [matTooltip]="label"
    [ngClass]="{'rounded': rounded && aspectRatio === 1}">
    }
    @if (isIconImage) {
    <span>{{model?.fileName ?? model?.imageExtension}}</span>
    <span class="file-size">{{model?.fileSize}}</span>
    }
  </div>
  }

  @if ((url || localUrl) && onlyImg) {
  <div class="img-loaded-container onlyImg" fxLayout="row" fxLayoutAlign="center center">
    <img class="img-uploaded" [src]="(url || localUrl) | safeUrl" [matTooltip]="label" [ngClass]="{'rounded': rounded && aspectRatio === 1}">
  </div>
  }

  @if (!(localUrl === undefined ? url : localUrl)) {
  <div class="upload-wrapper">
    <button fxLayout="column" fxLayoutAlign="center center" (click)="coverImage.click()" class="mat-focus-indicator mat-raised-button mat-button-base mat-primary uploadBtn2" type="button">
      <mat-icon fxLayout="column" fxLayoutAlign="center center">publish</mat-icon>
      <span>{{'langs.upload_image' | translateWithKeys}}</span>
    </button>
  </div>
  }
  <input #coverImage hidden type="file" (change)="fileChangeEvent($event)" (click)="coverImage.value = ''" name="coverImage" accept="image/jpeg, image/jpg, image/png, image/svg+xml">

  <ng-template #cropper>
    <div fxLayout="column">

      @if (!freeCropper && (imageChangedEvent !== null || imageFile !== null)) {
      <image-cropper class="cropped-img-container" fxFlex="100"
        [imageChangedEvent]="imageChangedEvent"
        [imageFile]="imageFile"
        [aspectRatio]="aspectRatio"
        [roundCropper]="rounded && aspectRatio === 1"
        alignImage="center"
        format="png"
        (imageCropped)="imageCropped($event)"
        (cropperReady)="onCropperReady($event)"
      ></image-cropper>
      }

      @if (freeCropper && (imageChangedEvent !== null || imageFile !== null)) {
      <image-cropper class="cropped-img-container" fxFlex="100"
        [imageChangedEvent]="imageChangedEvent"
        [imageFile]="imageFile"
        [aspectRatio]="aspectRatio"
        [maintainAspectRatio]="fitMode === 'original'"
        [roundCropper]="rounded && aspectRatio === 1"
        alignImage="center"
        format="png"
        (imageCropped)="imageCropped($event)"
        (cropperReady)="onCropperReady($event)"
      ></image-cropper>
      }

      <div fxLayout="row" fxLayoutAlign="end" class="mt-10">
        <button mat-raised-button (click)="removeImage()">Cancel</button>
        <button mat-raised-button class="primary-color" (click)="closeModal()" class="ml-10">Save</button>
      </div>
    </div>
  </ng-template>

  @if (!hiddenDelete) {
  <div class="delete">
	  @if (localUrl === undefined ? url : localUrl) {
	  <button mat-icon-button class="warn-color image-action-button" (click)="$event.stopPropagation(); removeImage();">
		  <mat-icon class="remove-btn">delete_forever</mat-icon>
	  </button>
	  }
  </div>
  }

  @if (downloadBtn) {
  <div class="download">
	  @if (localUrl === undefined ? url : localUrl) {
	  <button mat-icon-button class="accent-color image-action-button" (click)="$event.stopPropagation(); downloadImg();">
		  <mat-icon class="remove-btn">file_download</mat-icon>
	  </button>
	  }
  </div>
  }
</mat-card>

@if (recommendedSizeKey) {
  <div class="upload-recommended-size" role="note">
    <mat-icon aria-hidden="true">info_outline</mat-icon>
    <span>{{ recommendedSizeKey | translateWithKeys }}</span>
  </div>
}
